import type { Coupon, CouponIndex } from '../../../../schema/coupon/entry.js';
import {
  CouponEntity,
  type ICouponBoardEntity,
  type ICouponEntity,
  type IDefinition,
  NotFoundError,
} from '../../../domain/entry.js';
import type { ICouponZustandStoreService } from '../../services/couponStoreService.js';
import { CouponBoardZustandEntity } from './CouponBoardZustandEntity.js';
import { selectCoupon } from './selectors/selectCoupon.js';

type Store = ReturnType<ICouponZustandStoreService['bootstrap']>;

export class CouponZustandEntity extends CouponEntity implements ICouponEntity {
  private readonly _store: Store;

  // eslint-disable-next-line @typescript-eslint/max-params
  constructor(model: Coupon, couponIndex: CouponIndex, definition: IDefinition, store: Store) {
    super(model, couponIndex, definition);
    this._store = store;
  }

  override get model(): Coupon {
    const coupon = selectCoupon(this.couponId, { couponIndex: this.couponIndex })(this._store.getState());

    if (!coupon) {
      // Treat undefined as a special use case since normally this shouldn't happen,
      // this can happen due to that entity has access to the whole state so it gets updates to the model
      // without subscribing to it.
      throw new NotFoundError('Coupon entity not found');
    }

    return coupon;
  }

  override getBoard(boardIndex: number): ICouponBoardEntity | undefined {
    const boardModel = this.model.boards[boardIndex];

    if (!boardModel) {
      return undefined;
    }

    const couponBoardIdentifiers = {
      couponId: this.couponId,
      couponIndex: this.couponIndex,
      boardIndex,
    };

    return new CouponBoardZustandEntity(boardModel, couponBoardIdentifiers, this.definition, this._store);
  }
}
